import { ReactNode } from 'react'
import { useAuthorization } from '@hooks/useAuthorization'
import { RoleGateConfig } from '@/types'

interface RoleGuardProps extends Partial<RoleGateConfig> {
  children: ReactNode
  fallback?: ReactNode
}

export function RoleGuard({
  children,
  portal = 'customer',
  allowedRoles = [],
  requiredScopes = [],
  fallback
}: RoleGuardProps) {
  const { isAuthenticated, isLoading, evaluateGate } = useAuthorization()

  if (import.meta.env.DEV) {
    console.debug('[RoleGuard]', {
      portal,
      allowedRoles,
      requiredScopes,
      isAuthenticated,
      isLoading,
      gate: evaluateGate({ portal, allowedRoles, requiredScopes })
    })
  }

  if (!isLoading && !isAuthenticated) {
    return (
      fallback ?? (
        <div style={{ padding: '3rem', textAlign: 'center' }}>
          <h2>Sign In Required</h2>
          <p>Please sign in with the correct account to continue.</p>
        </div>
      )
    )
  }

  if (!evaluateGate({ portal, allowedRoles, requiredScopes })) {
    return (
      fallback ?? (
        <div style={{ padding: '3rem', textAlign: 'center' }}>
          <h2>Access Restricted</h2>
          <p>You do not have the required permissions to view this area.</p>
        </div>
      )
    )
  }

  return <>{children}</>
}
